(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5579:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "B": function() { return /* binding */ Registry; },
  "n": function() { return /* binding */ container_registry_container; }
});

// EXTERNAL MODULE: ./node_modules/reflect-metadata/Reflect.js
var Reflect = __webpack_require__(8660);
// EXTERNAL MODULE: ./node_modules/inversify/es/container/container.js + 35 modules
var container = __webpack_require__(7089);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(2777);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(2262);
;// CONCATENATED MODULE: ./src/@core/application/post/get-post.use-case.ts


//Dependency Inversion
var GetPostUseCase = /*#__PURE__*/function () {
  function GetPostUseCase(postGate) {
    (0,classCallCheck/* default */.Z)(this, GetPostUseCase);

    this.postGate = postGate;
  }

  (0,createClass/* default */.Z)(GetPostUseCase, [{
    key: "execute",
    value: function execute(slug) {
      return this.postGate.findBySlug(slug);
    }
  }]);

  return GetPostUseCase;
}();
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/@core/application/post/list-posts.use-case.ts




var ListPostsUseCase = /*#__PURE__*/function () {
  function ListPostsUseCase(postGate) {
    (0,classCallCheck/* default */.Z)(this, ListPostsUseCase);

    this.postGate = postGate;
  }

  (0,createClass/* default */.Z)(ListPostsUseCase, [{
    key: "execute",
    value: function () {
      var _execute = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(params) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.postGate.findAll(params));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute(_x) {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);

  return ListPostsUseCase;
}();
;// CONCATENATED MODULE: ./src/helpers/post-reading-time.ts
function readingTime(content) {
  var text = content;
  var wpm = 225;
  var words = text.trim().split(/\s+/).length;
  var time = Math.ceil(words / wpm);
  return time;
}
;// CONCATENATED MODULE: ./src/@core/domain/entities/post.ts


var Post = /*#__PURE__*/function () {
  function Post(props) {
    (0,classCallCheck/* default */.Z)(this, Post);

    this.props = props;
  }

  (0,createClass/* default */.Z)(Post, [{
    key: "id",
    get: function get() {
      return this.props.id;
    }
  }, {
    key: "slug",
    get: function get() {
      return this.props.slug;
    }
  }, {
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "description",
    get: function get() {
      return this.props.description;
    }
  }, {
    key: "content",
    get: function get() {
      return this.props.content;
    }
  }, {
    key: "category",
    get: function get() {
      return this.props.category;
    }
  }, {
    key: "date",
    get: function get() {
      return this.props.date;
    }
  }, {
    key: "media",
    get: function get() {
      return this.props.media;
    }
  }, {
    key: "authorId",
    get: function get() {
      return this.props.authorId;
    }
  }, {
    key: "readingTime",
    get: function get() {
      return this.props.readingTime;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var _this$content;

      return {
        id: this.id,
        slug: this.slug,
        title: this.title,
        description: this.description,
        content: (_this$content = this.content) !== null && _this$content !== void 0 ? _this$content : null,
        category: this.category,
        date: this.date,
        media: this.media,
        authorId: this.authorId,
        readingTime: this.readingTime
      };
    }
  }]);

  return Post;
}();
;// CONCATENATED MODULE: ./src/@core/infra/gateways/post-http.gateway.ts






var PostHttpGateway = /*#__PURE__*/function () {
  function PostHttpGateway(http) {
    (0,classCallCheck/* default */.Z)(this, PostHttpGateway);

    this.http = http;
  }

  (0,createClass/* default */.Z)(PostHttpGateway, [{
    key: "findAll",
    value: function () {
      var _findAll = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(params) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.http.get('/wp/v2/posts', {
                  params: params
                }).then(function (res) {
                  return res.data.map(function (data) {
                    return new Post({
                      id: data.id,
                      slug: data.slug,
                      title: data.title.rendered,
                      description: data.excerpt.rendered,
                      category: data.categories[0],
                      content: null,
                      date: data.date,
                      media: data.jetpack_featured_media_url,
                      authorId: data.author,
                      readingTime: readingTime(data.content.rendered)
                    }).toJSON();
                  });
                })["catch"](function (err) {
                  return err;
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findAll(_x) {
        return _findAll.apply(this, arguments);
      }

      return findAll;
    }()
  }, {
    key: "findBySlug",
    value: function () {
      var _findBySlug = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(slug) {
        var params;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                params = {
                  slug: slug
                };
                return _context2.abrupt("return", this.http.get("/wp/v2/posts", {
                  params: params
                }).then(function (res) {
                  var data = res.data.shift();
                  return new Post({
                    id: data.id,
                    slug: data.slug,
                    title: data.title.rendered,
                    description: data.excerpt.rendered,
                    content: data.content.rendered,
                    category: data.categories[0],
                    date: data.date,
                    media: data.jetpack_featured_media_url,
                    authorId: data.author,
                    readingTime: readingTime(data.content.rendered)
                  }).toJSON();
                })["catch"](function (err) {
                  return err;
                }));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function findBySlug(_x2) {
        return _findBySlug.apply(this, arguments);
      }

      return findBySlug;
    }()
  }, {
    key: "listMostSeenPosts",
    value: function () {
      var _listMostSeenPosts = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
        return regenerator_default().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.http.get('/wp_query/args?meta_key=post_views_count&orderby=meta_value_num&posts_per_page=4&ignore_sticky_posts=true').then(function (res) {
                  return res.data.map(function (data) {
                    return new Post({
                      id: data.id,
                      slug: data.slug,
                      title: data.title.rendered,
                      description: data.excerpt.rendered,
                      category: data.categories[0],
                      content: null,
                      date: data.date,
                      media: data.jetpack_featured_media_url,
                      authorId: data.author,
                      readingTime: readingTime(data.content.rendered)
                    }).toJSON();
                  });
                })["catch"](function (err) {
                  return err;
                }));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function listMostSeenPosts() {
        return _listMostSeenPosts.apply(this, arguments);
      }

      return listMostSeenPosts;
    }()
  }]);

  return PostHttpGateway;
}();
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/@core/infra/http.ts

var http = axios_default().create({
  baseURL: "https://kenzie.com.br/blog/wp-json"
});
;// CONCATENATED MODULE: ./src/@core/domain/entities/author.ts


var Author = /*#__PURE__*/function () {
  function Author(props) {
    (0,classCallCheck/* default */.Z)(this, Author);

    this.props = props;
  }

  (0,createClass/* default */.Z)(Author, [{
    key: "id",
    get: function get() {
      return this.props.id;
    }
  }, {
    key: "name",
    get: function get() {
      return this.props.name;
    }
  }, {
    key: "avatarUrl",
    get: function get() {
      return this.props.avatarUrl;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        id: this.id,
        name: this.name,
        avatarUrl: this.avatarUrl
      };
    }
  }]);

  return Author;
}();
;// CONCATENATED MODULE: ./src/@core/infra/gateways/author-http.gateway.ts





var AuthorHttpGateway = /*#__PURE__*/function () {
  function AuthorHttpGateway(http) {
    (0,classCallCheck/* default */.Z)(this, AuthorHttpGateway);

    this.http = http;
  }

  (0,createClass/* default */.Z)(AuthorHttpGateway, [{
    key: "findById",
    value: function () {
      var _findById = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(id) {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.http.get("/wp/v2/users/".concat(id)).then(function (res) {
                  return new Author({
                    id: res.data.id,
                    name: res.data.name,
                    avatarUrl: res.data.avatar_urls['96']
                  });
                }));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function findById(_x) {
        return _findById.apply(this, arguments);
      }

      return findById;
    }()
  }]);

  return AuthorHttpGateway;
}();
;// CONCATENATED MODULE: ./src/@core/application/author/get-author.use-case.ts


//Dependency Inversion
var GetAuthorUseCase = /*#__PURE__*/function () {
  function GetAuthorUseCase(authorGate) {
    (0,classCallCheck/* default */.Z)(this, GetAuthorUseCase);

    this.authorGate = authorGate;
  }

  (0,createClass/* default */.Z)(GetAuthorUseCase, [{
    key: "execute",
    value: function execute(id) {
      return this.authorGate.findById(id);
    }
  }]);

  return GetAuthorUseCase;
}();
;// CONCATENATED MODULE: ./src/@core/application/post/list-most-seen-posts.ts




var ListMostSeenPostsUseCase = /*#__PURE__*/function () {
  function ListMostSeenPostsUseCase(postGate) {
    (0,classCallCheck/* default */.Z)(this, ListMostSeenPostsUseCase);

    this.postGate = postGate;
  }

  (0,createClass/* default */.Z)(ListMostSeenPostsUseCase, [{
    key: "execute",
    value: function () {
      var _execute = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.postGate.listMostSeenPosts());

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function execute() {
        return _execute.apply(this, arguments);
      }

      return execute;
    }()
  }]);

  return ListMostSeenPostsUseCase;
}();
;// CONCATENATED MODULE: ./src/@core/infra/container-registry.ts









var Registry = {
  AxiosAdapter: Symbol["for"]('AxiosAdapter'),
  PostGateway: Symbol["for"]('PostGateway'),
  AuthorGateway: Symbol["for"]('AuthorGateway'),
  ListPostsUseCase: Symbol["for"]('ListPostsUseCase'),
  GetPostUseCase: Symbol["for"]('GetPostUseCase'),
  ListMostSeenPostsUseCase: Symbol["for"]('ListMostSeenPostsUseCase'),
  GetAuthorUseCase: Symbol["for"]('GetAuthorUseCase')
};
var container_registry_container = new container/* Container */.W(); //########## HTTP

container_registry_container.bind(Registry.AxiosAdapter).toConstantValue(http); //########## GATEWAYS

container_registry_container.bind(Registry.PostGateway).toDynamicValue(function (context) {
  return new PostHttpGateway(context.container.get(Registry.AxiosAdapter));
});
container_registry_container.bind(Registry.AuthorGateway).toDynamicValue(function (context) {
  return new AuthorHttpGateway(context.container.get(Registry.AxiosAdapter));
}); //########## USE CASES

container_registry_container.bind(Registry.ListPostsUseCase).toDynamicValue(function (context) {
  return new ListPostsUseCase(context.container.get(Registry.PostGateway));
});
container_registry_container.bind(Registry.GetPostUseCase).toDynamicValue(function (context) {
  return new GetPostUseCase(context.container.get(Registry.PostGateway));
});
container_registry_container.bind(Registry.ListMostSeenPostsUseCase).toDynamicValue(function (context) {
  return new ListMostSeenPostsUseCase(context.container.get(Registry.PostGateway));
});
container_registry_container.bind(Registry.GetAuthorUseCase).toDynamicValue(function (context) {
  return new GetAuthorUseCase(context.container.get(Registry.AuthorGateway));
});

/***/ }),

/***/ 5802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CustomPagination; }
/* harmony export */ });
/* harmony import */ var _mui_material_Pagination__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1330);
/* harmony import */ var _mui_material_Stack__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9144);
/* harmony import */ var _mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1225);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2125);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);





var Container = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CustomPagination__Container",
  componentId: "sc-140aqx9-0"
})([".MuiPagination-ul{max-width:100%;}.MuiPaginationItem-root{font-weight:700 !important;&:hover{background:#d2d2d2 !important;}}.Mui-selected{background:var(--highlight-blue) !important;&:hover{background:var(--highlight-blue) !important;}}"]);
function CustomPagination(_ref) {
  var handleChange = _ref.handleChange,
      page = _ref.page,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 1 : _ref$count;
  var isMobile = (0,_mui_material_useMediaQuery__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)('(max-width: 540px)');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Container, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Stack__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      spacing: 1,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Pagination__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        count: count,
        size: isMobile ? 'small' : 'medium',
        page: page,
        color: "primary",
        onChange: handleChange
      })
    })
  });
}

/***/ }),

/***/ 7799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Home; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/Header/index.tsx + 3 modules
var Header = __webpack_require__(98);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(29);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(7794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/@core/infra/container-registry.ts + 10 modules
var container_registry = __webpack_require__(5579);
// EXTERNAL MODULE: ./src/components/CustomPagination/index.tsx
var CustomPagination = __webpack_require__(5802);
// EXTERNAL MODULE: ./src/components/PostCard/index.tsx + 2 modules
var PostCard = __webpack_require__(9252);
// EXTERNAL MODULE: ./src/components/Title/index.tsx + 1 modules
var Title = __webpack_require__(2422);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./src/components/LatestContents/styles.ts

var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styles__Container",
  componentId: "sc-hoogsm-0"
})(["padding-top:2.5rem;width:85%;max-width:var(--max-width);border-bottom:1px solid #dddddd;margin:0 auto;@media (min-width:1024px){padding:4.25rem 0 2.5rem;max-width:1170px;}"]);
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__List",
  componentId: "sc-hoogsm-1"
})(["display:flex;flex-wrap:wrap;justify-content:flex-start;gap:2.5rem 3.6rem;margin:0 auto;@media (max-width:1200px){justify-content:center;}"]);
var PaginationContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__PaginationContainer",
  componentId: "sc-hoogsm-2"
})(["margin:0 auto;padding:4.5rem 0 2.5rem;width:fit-content;"]);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./src/components/LatestContents/index.tsx










function LatestContents(_ref) {
  var posts = _ref.posts;

  var _useState = (0,react.useState)(posts),
      postsList = _useState[0],
      setPostsList = _useState[1];

  var _useState2 = (0,react.useState)(1),
      page = _useState2[0],
      setPage = _useState2[1];

  var _useState3 = (0,react.useState)(false),
      isLoading = _useState3[0],
      setIsLoading = _useState3[1];

  var ref = (0,react.useRef)(null);

  function scrollToRef() {
    if (ref.current) window.scrollTo({
      top: ref.current.offsetTop - 180
    });
  }

  var fetchPosts = /*#__PURE__*/function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(page) {
      var listPostsUseCase, posts;
      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              listPostsUseCase = container_registry/* container.get */.n.get(container_registry/* Registry.ListPostsUseCase */.B.ListPostsUseCase);
              _context.next = 3;
              return listPostsUseCase.execute({
                per_page: 12,
                page: page
              });

            case 3:
              posts = _context.sent;
              return _context.abrupt("return", posts);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchPosts(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleChange = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(event, value) {
      var posts;
      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setIsLoading(true);
              setPage(value);
              _context2.next = 4;
              return fetchPosts(value);

            case 4:
              posts = _context2.sent;
              setPostsList(posts);
              setIsLoading(false);
              scrollToRef();

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleChange(_x2, _x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      ref: ref,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        children: "\xDALTIMOS CONTE\xDADOS"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
      children: postsList.map(function (post, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PostCard/* default */.Z, {
          post: post,
          showCategory: true,
          isLoading: isLoading
        }, index);
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationContainer, {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(CustomPagination/* default */.Z, {
        handleChange: handleChange,
        page: page,
        count: 20
      })
    })]
  });
}
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(2546);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 89 modules
var swiper_esm = __webpack_require__(4988);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(5935);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(6797);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.min.css
var autoplay_min = __webpack_require__(3731);
;// CONCATENATED MODULE: ./src/shared/icons.tsx


function Sun(_ref) {
  var color = _ref.color;
  return /*#__PURE__*/_jsx("svg", {
    width: "29",
    height: "29",
    fill: "none",
    viewBox: "0 0 29 29",
    children: /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M14.102 23.397c-5.128 0-9.294-4.167-9.294-9.295s4.166-9.294 9.294-9.294 9.295 4.166 9.295 9.294-4.167 9.295-9.295 9.295zm0-16.666c-4.064 0-7.371 3.307-7.371 7.371s3.307 7.372 7.371 7.372 7.372-3.308 7.372-7.372-3.308-7.371-7.372-7.371zM14.102 28.153c-.705 0-1.282-.526-1.282-1.231v-.103c0-.705.577-1.282 1.282-1.282.705 0 1.282.577 1.282 1.282 0 .706-.577 1.334-1.282 1.334zm9.154-3.615c-.334 0-.654-.129-.91-.372l-.167-.167c-.5-.5-.5-1.308 0-1.808s1.307-.5 1.807 0l.167.167a1.277 1.277 0 01-.897 2.18zm-18.307 0c-.334 0-.654-.129-.91-.372-.5-.5-.5-1.308 0-1.808l.166-.167c.5-.5 1.308-.5 1.808 0s.5 1.308 0 1.808l-.167.167a1.283 1.283 0 01-.897.372zm21.973-9.154h-.103a1.286 1.286 0 01-1.282-1.282c0-.705.577-1.282 1.282-1.282.706 0 1.334.577 1.334 1.282 0 .705-.526 1.282-1.231 1.282zm-25.537 0h-.103A1.286 1.286 0 010 14.102c0-.705.577-1.282 1.282-1.282.705 0 1.333.577 1.333 1.282 0 .705-.525 1.282-1.23 1.282zm21.704-8.987c-.333 0-.654-.128-.91-.372-.5-.5-.5-1.307 0-1.807l.166-.167c.5-.5 1.308-.5 1.808 0s.5 1.308 0 1.808l-.167.166a1.261 1.261 0 01-.897.372zm-17.974 0c-.333 0-.654-.128-.91-.372l-.167-.18c-.5-.5-.5-1.307 0-1.807s1.308-.5 1.808 0l.167.167c.5.5.5 1.308 0 1.808a1.244 1.244 0 01-.898.384zm8.987-3.782c-.705 0-1.282-.525-1.282-1.23v-.103C12.82.577 13.397 0 14.102 0c.705 0 1.282.577 1.282 1.282 0 .705-.577 1.333-1.282 1.333z"
    })
  });
}
function Moon(_ref2) {
  var color = _ref2.color;
  return /*#__PURE__*/_jsx("svg", {
    width: "23",
    height: "25",
    fill: "none",
    viewBox: "0 0 23 25",
    children: /*#__PURE__*/_jsx("path", {
      fill: color,
      d: "M12.23 24.153c-.186 0-.372 0-.557-.011C5.563 23.869.457 18.948.031 12.947-.339 7.797 2.64 2.986 7.44.967 8.803.4 9.524.837 9.829 1.153c.305.305.731 1.014.164 2.313A8.943 8.943 0 009.25 7.12c.022 4.833 4.037 8.936 8.936 9.132a9.432 9.432 0 002.084-.142c1.44-.262 2.04.317 2.27.688.228.37.49 1.167-.383 2.346-2.313 3.164-5.99 5.008-9.929 5.008zM1.656 12.827c.37 5.194 4.8 9.449 10.081 9.678a10.618 10.618 0 009.09-4.32c.163-.23.24-.393.272-.48a1.718 1.718 0 00-.546.032c-.796.142-1.625.196-2.444.164-5.76-.23-10.474-5.063-10.507-10.758 0-1.506.295-2.957.895-4.321.109-.24.13-.404.142-.491-.098 0-.273.022-.557.142-4.157 1.745-6.732 5.913-6.426 10.354z"
    })
  });
}
function Clock() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "30",
    height: "30",
    fill: "none",
    viewBox: "0 0 30 30",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "30",
      height: "30",
      fill: "#F7C82A",
      rx: "8"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#112EF7",
      d: "M15.262 23.063C10.816 23.063 7.2 19.447 7.2 15c0-4.447 3.615-8.063 8.063-8.063 4.447 0 8.062 3.615 8.062 8.063s-3.615 8.063-8.063 8.063zm0-15A6.946 6.946 0 008.325 15a6.946 6.946 0 006.938 6.938A6.946 6.946 0 0022.2 15a6.946 6.946 0 00-6.938-6.938z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#112EF7",
      d: "M18.045 17.948a.502.502 0 01-.285-.083l-2.325-1.387c-.578-.345-1.005-1.103-1.005-1.77v-3.075c0-.308.255-.563.562-.563.308 0 .563.255.563.563v3.075c0 .27.225.667.457.802l2.325 1.388c.27.157.353.502.195.772a.578.578 0 01-.487.278z"
    })]
  });
}
function Computer() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "30",
    height: "30",
    fill: "none",
    viewBox: "0 0 30 30",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "30",
      height: "30",
      fill: "#F7C82A",
      rx: "8"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#112EF7",
      d: "M19.138 19.443h-8.276C7.9 19.443 7 18.543 7 15.58v-4.718C7 7.9 7.9 7 10.862 7h8.268c2.962 0 3.863.9 3.863 3.862v4.71c.007 2.97-.893 3.87-3.855 3.87zM10.862 8.116c-2.336 0-2.746.41-2.746 2.746v4.71c0 2.338.41 2.747 2.746 2.747h8.268c2.337 0 2.746-.41 2.746-2.746v-4.71c0-2.337-.409-2.747-2.746-2.747h-8.268z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#112EF7",
      d: "M15 23a.562.562 0 01-.558-.558v-3.557c0-.305.253-.559.558-.559.305 0 .558.254.558.559v3.557A.562.562 0 0115 23zM22.442 16.302H7.558A.562.562 0 017 15.744c0-.305.253-.558.558-.558h14.884c.305 0 .558.253.558.558a.562.562 0 01-.558.558z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#112EF7",
      d: "M18.349 23H11.65a.562.562 0 01-.558-.558c0-.305.253-.558.558-.558h6.698c.305 0 .558.253.558.558a.562.562 0 01-.558.558z"
    })]
  });
}
function Calendar() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "30",
    height: "30",
    fill: "none",
    viewBox: "0 0 30 30",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "30",
      height: "30",
      fill: "#F7C82A",
      rx: "8"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#112EF7",
      d: "M12.113 10.975a.567.567 0 01-.563-.563v-2.25c0-.307.255-.562.563-.562.307 0 .562.255.562.562v2.25a.567.567 0 01-.562.563zM18.113 10.975a.567.567 0 01-.563-.563v-2.25c0-.307.255-.562.563-.562.307 0 .562.255.562.562v2.25a.567.567 0 01-.562.563zM21.488 14.042H8.738a.567.567 0 01-.563-.562c0-.308.255-.563.563-.563h12.75c.307 0 .562.255.562.563a.567.567 0 01-.562.562z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#112EF7",
      d: "M18.112 23.725h-6c-2.737 0-4.312-1.575-4.312-4.313v-6.375c0-2.737 1.575-4.312 4.312-4.312h6c2.738 0 4.313 1.575 4.313 4.312v6.375c0 2.738-1.575 4.313-4.313 4.313zm-6-13.875c-2.145 0-3.187 1.042-3.187 3.187v6.375c0 2.146 1.042 3.188 3.187 3.188h6c2.145 0 3.188-1.043 3.188-3.188v-6.375c0-2.145-1.043-3.187-3.188-3.187h-6z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#112EF7",
      d: "M12.488 17.537a.747.747 0 01-.285-.06.866.866 0 01-.248-.157.866.866 0 01-.158-.248.747.747 0 01-.06-.285c0-.195.083-.39.218-.532a.866.866 0 01.248-.158.717.717 0 01.57 0c.045.015.09.038.135.068l.112.09c.03.037.068.075.09.112.03.045.053.09.068.135.022.045.037.09.045.135.007.053.015.098.015.15 0 .195-.083.39-.218.533a.788.788 0 01-.532.217zM15.113 17.537a.789.789 0 01-.533-.217l-.09-.113a.568.568 0 01-.068-.135.477.477 0 01-.045-.135c-.007-.052-.014-.097-.014-.15 0-.097.022-.195.06-.285a.866.866 0 01.157-.247.752.752 0 01.818-.158c.097.038.172.09.247.158a.789.789 0 01.218.532c0 .053-.008.098-.015.15a.477.477 0 01-.045.135.568.568 0 01-.068.135l-.09.113a.774.774 0 01-.247.157.747.747 0 01-.285.06zM12.488 20.162a.747.747 0 01-.285-.06.866.866 0 01-.248-.157.774.774 0 01-.158-.248.747.747 0 01-.06-.285c0-.195.083-.39.218-.532a.866.866 0 01.248-.158.75.75 0 01.817.158c.03.037.068.075.09.112.03.045.053.09.068.135.022.045.037.09.045.143a.919.919 0 01.015.142c0 .195-.083.39-.218.533a.788.788 0 01-.532.217z"
    })]
  });
}
function Arrow() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "56",
    height: "16",
    fill: "none",
    viewBox: "0 0 56 16",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fill: "#fff",
      d: "M54.888 8.422a1 1 0 000-1.414L48.524.644a1 1 0 10-1.415 1.414l5.657 5.657-5.657 5.657a1 1 0 001.415 1.414l6.364-6.364zM0 8.715h54.18v-2H0v2z"
    })
  });
}
// EXTERNAL MODULE: ./src/helpers/categories.ts
var categories = __webpack_require__(5676);
// EXTERNAL MODULE: ./src/components/Carousel/carousel-custom-styles.module.css
var carousel_custom_styles_module = __webpack_require__(3156);
var carousel_custom_styles_module_default = /*#__PURE__*/__webpack_require__.n(carousel_custom_styles_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/components/Carousel/styles.tsx


var StyledCarousel = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styles__StyledCarousel",
  componentId: "sc-1kmhncx-0"
})(["margin:0 auto;background:var(--highlight-blue);position:relative;.swiper-pagination{position:absolute;bottom:15px;left:0;right:0;}@media (min-width:1100px){.swiper-horizontal{position:initial !important;}.swiper-slide{position:initial !important;}.swiper-wrapper{height:675px;}.swiper-pagination{bottom:20px;}}"]);
var CarouselCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__CarouselCard",
  componentId: "sc-1kmhncx-1"
})(["width:100%;height:100%;@media (min-width:1100px){flex-direction:row;}"]);
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__Wrapper",
  componentId: "sc-1kmhncx-2"
})(["max-width:var(--max-width);margin:0 auto;width:85%;"]);
var CarouselCardHeader = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__CarouselCardHeader",
  componentId: "sc-1kmhncx-3"
})(["background:url(", ") no-repeat center;background-size:cover;height:115px;width:100%;margin-bottom:-4px;@media (min-width:768px){height:230px;}@media (min-width:1100px){margin-bottom:0;background-size:cover;height:100%;position:absolute;width:50%;right:0;z-index:1;}"], function (_ref) {
  var image = _ref.image;
  return image && image;
});
var CarouselCardContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__CarouselCardContent",
  componentId: "sc-1kmhncx-4"
})(["width:85%;margin:0 auto;padding:1.75rem 0 2.5rem;color:var(--text-color-secondary);display:flex;flex-direction:column;.category-container{display:flex;flex-direction:column;gap:1rem;}.category{font-size:1.325rem;font-weight:600;color:var(--highlight-blue);background:var(--text-color-secondary);display:inline-block;padding:0.25rem 1.75rem;width:max-content;margin-bottom:0.8rem;}.reading-time{display:inline-block;font-size:0.875rem;font-weight:400;}h2{font-family:'Montserrat',sans-serif;font-size:1.625rem;margin:1.5rem 0;}p{font-size:1.25rem;margin-bottom:1.5rem;}@media (min-width:768px){.category-container{flex-direction:row;align-items:center;gap:1.2rem;}.category{margin-bottom:0;}}@media (min-width:1100px){max-width:453px;margin:0 0;padding:5.5rem 0 3rem;.category-container{margin-bottom:2rem;}h2{font-size:1.95rem;}p{font-size:1.475rem;margin-bottom:3rem;}}@media (min-width:1100px){h2{font-size:2.15rem;margin-bottom:2.15rem;}p{font-size:1.6rem;}}"]);
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)((link_default())).withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-1kmhncx-5"
})(["font-family:'Montserrat',sans-serif;color:var(--text-color-secondary);font-size:1rem;text-transform:uppercase;font-weight:700;display:flex;align-items:center;justify-content:space-between;gap:0.5rem;width:13rem;padding:1rem;margin:auto 0 1rem;border-radius:2px;border:2px solid #fff;transition:border,background 0.3s ease-in-out;&:hover{background:#0a1e32;border-color:#0a1e32;}@media (min-width:768px){margin-bottom:1rem;}@media (min-width:1100px){width:15rem;font-size:1.325rem;margin-bottom:0;}"]);
;// CONCATENATED MODULE: ./src/components/Carousel/index.tsx












function Carousel(_ref) {
  var posts = _ref.posts;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledCarousel, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
      spaceBetween: 50,
      slidesPerView: 1,
      modules: [swiper_esm/* Pagination */.tl, swiper_esm/* Autoplay */.pt],
      pagination: {
        clickable: true,
        bulletClass: (carousel_custom_styles_module_default()).bulletClass,
        bulletActiveClass: (carousel_custom_styles_module_default()).bulletActiveClass
      },
      autoplay: true,
      loop: true,
      children: posts.map(function (post, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CarouselCard, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CarouselCardHeader, {
              image: post.media
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Wrapper, {
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(CarouselCardContent, {
                children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "category-container",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                    className: "category",
                    children: (0,categories/* translateCategoryById */.b7)(post.category).name
                  }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
                    className: "reading-time",
                    children: [post.readingTime, " min de leitura"]
                  })]
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
                  children: post.title
                }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  children: (0,html_react_parser/* default */.ZP)(post.description)
                }), /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLink, {
                  href: "/".concat(post.slug),
                  children: ["Leia mais", /*#__PURE__*/(0,jsx_runtime.jsx)(Arrow, {})]
                })]
              })
            })]
          })
        }, index);
      })
    })
  });
}
;// CONCATENATED MODULE: ./src/styles/pages/home.ts

var Background = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
  displayName: "home__Background",
  componentId: "sc-vn8fyp-0"
})(["background:linear-gradient(131.31deg,#f5f5f5 3.65%,#92b7fb 100%);"]);
var Content = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "home__Content",
  componentId: "sc-vn8fyp-1"
})(["max-width:var(--max-width);margin:0 auto;padding:3.5rem 0;width:90%;@media (min-width:360px){width:85%;}@media (min-width:1024px){padding:5rem 0;}"]);
var home_Title = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
  displayName: "home__Title",
  componentId: "sc-vn8fyp-2"
})(["background-color:#0a1e32;padding:7.55rem 0 1rem;text-align:center;text-transform:uppercase;color:var(--text-color-secondary);font-size:1.35rem;"]);
// EXTERNAL MODULE: ./src/components/CategoriesSection/index.tsx + 3 modules
var CategoriesSection = __webpack_require__(6651);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(4231);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.module.js + 1 modules
var yup_module = __webpack_require__(5496);
// EXTERNAL MODULE: ./node_modules/react-icons/bi/index.esm.js
var bi_index_esm = __webpack_require__(7516);
;// CONCATENATED MODULE: ./src/components/MostSeenPosts/styles.ts

var styles_Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "styles__Container",
  componentId: "sc-upl780-0"
})(["padding-top:2.5rem;margin:0 auto;max-width:1170px;width:85%;@media (min-width:1024px){padding:4.25rem 0 2.5rem;}"]);
var TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "styles__TitleContainer",
  componentId: "sc-upl780-1"
})(["display:flex;flex-direction:column-reverse;gap:2rem;@media (min-width:768px){flex-direction:row;align-items:center;justify-content:space-between;margin-bottom:2.5rem;h2{margin-bottom:0;}}@media (min-width:1024px){margin-bottom:4.5rem;}"]);
var styles_List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "styles__List",
  componentId: "sc-upl780-2"
})(["display:flex;flex-direction:column;gap:1rem;margin:0 auto;@media (min-width:1024px){height:32.625rem;gap:0;justify-content:space-between;flex-wrap:wrap;margin:0;width:100%;}"]);
var Card = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "styles__Card",
  componentId: "sc-upl780-3"
})(["background:#f5f5f5;border-radius:20px;height:9.375rem;transition:all 0.3s ease-in-out;.content{overflow:hidden;max-width:530px;display:flex;flex-direction:column;justify-content:space-between;padding:1rem 1.5rem;height:100%;}a{height:100%;width:100%;}&:hover{box-shadow:4px 4px 5px 0 rgba(0,0,0,0.2);}.category{color:var(--highlight-blue);display:block;font-size:1.125rem;font-weight:600;}.title{font-size:1.2rem;font-family:'Montserrat',sans-serif;font-weight:600;}@media (min-width:1024px){.title{font-size:1.375rem;}}@media (min-width:1100px){.content{max-width:600px;}}"]);
var HighlightedCard = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "styles__HighlightedCard",
  componentId: "sc-upl780-4"
})(["width:fit-content;border-radius:20px;transition:all 0.3s ease-in-out;img{display:block;height:30%;width:100%;object-fit:cover;border-top-left-radius:20px;border-top-right-radius:20px;}a{background:#f5f5f5;border-radius:20px;width:100%;display:flex;flex-direction:column;transition:all 0.3s ease-in-out;}&:hover{box-shadow:4px 4px 5px 0 rgba(0,0,0,0.2);}.content{padding:1.5rem;display:flex;flex-direction:column;justify-content:space-between;background:var(--highlight-blue);color:var(--text-color-secondary);border-bottom-left-radius:20px;border-bottom-right-radius:20px;max-width:none;min-height:14rem;}.category{color:#b9c3d7;display:block;font-size:1.125rem;font-weight:600;}.title{font-size:1.2rem;font-family:'Montserrat',sans-serif;font-weight:600;}.description{p{font-size:1rem;}}@media (min-width:370px){.title{font-size:1.725rem;}}@media (min-width:1024px){max-width:none;.content{gap:1rem;flex-grow:1;}a{height:32.625rem;width:23.313rem;}img{height:25%;}}@media (min-width:1400px){.content{flex-grow:initial;height:50%;}a{height:32.625rem;width:38.313rem;margin-bottom:0;}img{height:50%;}}"]);
var SearchForm = styled_components_browser_esm/* default.form.withConfig */.ZP.form.withConfig({
  displayName: "styles__SearchForm",
  componentId: "sc-upl780-5"
})(["background:#f5f5f5;border-radius:10px;width:100%;height:3.75rem;display:flex;align-items:center;justify-content:space-between;input{background:#f5f5f5;color:#b9b9b9;padding-left:1rem;border-radius:10px;font-size:1.25rem;height:100%;width:75%;}button{background:0 0;height:2.375rem;padding:0 1.5rem;display:flex;align-items:center;justify-content:center;border-top-right-radius:10px;border-bottom-right-radius:10px;svg{font-size:1.275rem;}&:hover{svg{path{fill:var(--highlight-blue);}}}}@media (min-width:768px){width:14.5rem;height:2.5rem;input{font-size:1rem;padding-left:1.2rem;}button{padding:0.8rem;}}"]);
;// CONCATENATED MODULE: ./src/components/MostSeenPosts/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














function MostSeenPosts(_ref) {
  var posts = _ref.posts;
  var highlightedPost = posts[0];

  var _useRouter = (0,router.useRouter)(),
      push = _useRouter.push;

  var schema = es/* object */.Ry().shape({
    search: es/* string */.Z_().required('')
  });

  var _useForm = (0,index_esm/* useForm */.cI)({
    resolver: (0,yup_module/* yupResolver */.X)(schema),
    mode: 'onChange'
  }),
      register = _useForm.register,
      handleSubmit = _useForm.handleSubmit;

  var onSearch = function onSearch(data) {
    push("/buscar?s=".concat(data.search));
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
        children: "Mais Vistos"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(SearchForm, {
        onSubmit: handleSubmit(onSearch),
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("input", _objectSpread({
          type: "search",
          required: true,
          placeholder: "Pesquisar"
        }, register('search'))), /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(bi_index_esm/* BiSearchAlt2 */.wnI, {})
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(styles_List, {
      children: [highlightedPost ? /*#__PURE__*/(0,jsx_runtime.jsx)(HighlightedCard, {
        children: /*#__PURE__*/(0,jsx_runtime.jsxs)((link_default()), {
          href: "/".concat(highlightedPost.slug),
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
            src: highlightedPost.media,
            alt: "imagem",
            width: 364,
            height: 85
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "content",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
              className: "category",
              children: categories/* categories */.bd[highlightedPost.category].name
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
              className: "title",
              children: highlightedPost.title
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "description",
              children: (0,html_react_parser/* default */.ZP)(highlightedPost.description)
            }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
              children: [highlightedPost.readingTime, " min de leitura"]
            })]
          })]
        })
      }) : null, posts.slice(1).map(function (post, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(Card, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/".concat(post.slug),
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "content",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                className: "category",
                children: categories/* categories */.bd[post.category].name
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "title",
                children: post.title
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
                children: [post.readingTime, " min de leitura"]
              })]
            })
          })
        }, index);
      })]
    })]
  });
}
;// CONCATENATED MODULE: ./src/pages/index.tsx










var __N_SSG = true;
function Home(_ref) {
  var featuredPosts = _ref.featuredPosts,
      initialPosts = _ref.initialPosts,
      mostSeenPosts = _ref.mostSeenPosts;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Blog - Kenzie Academy Brasil"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://kenzie.com.br/blog"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Header/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(home_Title, {
        children: "BLOG DA KENZIE ACADEMY"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Carousel, {
        posts: featuredPosts
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(MostSeenPosts, {
        posts: mostSeenPosts
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LatestContents, {
        posts: initialPosts
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CategoriesSection/* default */.Z, {})]
    })]
  });
}

/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(7799);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3156:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bulletActiveClass":"carousel-custom-styles_bulletActiveClass__rcZFs","bulletClass":"carousel-custom-styles_bulletClass__7jxSm"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [874,692,352,173,100,690,450,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);